import { Component as AngularComponent, OnInit as AngularOnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { RouterLink } from '@angular/router';

// Services
import { StockDetailService } from '../../../../Services/Stock-Details/stock-detail.service';
import { ExpenseService } from '../../../../Services/Expenses/expense.service';
import { AssetService } from '../../../../Services/asset.service';
import { AuthService } from '../../../../Services/auth.service';
import { UserCustomerService } from '../../../../Services/User/Customer/user-customer.service';
import { UserStaffService } from '../../../../Services/User/Staff/user-staff.service';
import { StaffResetPasswordComponent } from '../staff-reset-password/staff-reset-password.component';

@AngularComponent({
  selector: 'app-sales-analysis',
  standalone: true,
  imports: [CommonModule, RouterLink,StaffResetPasswordComponent],
  templateUrl: './sales-analysis.component.html',
  styleUrl: './sales-analysis.component.css'
})

export class SalesAnalysisComponent implements AngularOnInit {

  stats = {
    newStockToday: 0,
    totalStock: 0, // This is your "Available Stock"
    submittedStock: 0,
    soldStock: 0,
    pendingUdhar: 0,
    totalExpenses: 0,
    assignedAssets: 0
  };

  isResettingPassword: boolean = false; 

  targetData = {
    total: 1000000,
    achieved: 250000,
    month: 'December 2025'
  };

  topCustomers: any[] = [];
  userData: any;
  userId!: number;

  constructor(
    private stockService: StockDetailService,
    private customerService: UserCustomerService,
    private expenseService: ExpenseService,
    private assetService: AssetService,
    private authService: AuthService,
    private staffService:UserStaffService
  ) {}

  ngOnInit() {
    this.userId = this.authService.getUserId().toString();
    this.loadData();
  }


  loadData() {
    const userId = this.userId;
    const todayStr = new Date().setHours(0,0,0,0);

    this.staffService.getUserStaffById(userId).subscribe((response:any)=>{
      this.userData = response.data;
      console.log("user data",this.userData);
      
    })

    // Stock Logic (Available = Total)
    this.stockService.getStockDetails(new HttpParams().set('stock_status', 'in').set('issued_stock_id', userId))
      .subscribe((res: any) => {
        const data = res.data || [];
        this.stats.totalStock = data.length; // Available Stock
        this.stats.newStockToday = data.filter((item: any) => {
          const d = new Date(item.updated_at).setHours(0,0,0,0);
          return d === todayStr;
        }).length;
      });

    this.stockService.getStockDetails(new HttpParams().set('stock_status', 'sold').set('issued_stock_id', userId))
      .subscribe((res: any) => this.stats.soldStock = res.data?.length || 0);

    this.stockService.getStockDetails(new HttpParams().set('returned_by_staff_id', userId))
      .subscribe((res: any) => this.stats.submittedStock = res.data?.length || 0);

    // Udhar (Pending Payments)
    this.customerService.getUserCustomers(new HttpParams().set('staff_id', userId))
      .subscribe((res: any) => {
        this.stats.pendingUdhar = res.data?.reduce((sum: number, c: any) => sum + Number(c.balance_due || 0), 0) || 0;
      });

    // Operations
    this.expenseService.getExpenses(new HttpParams()).subscribe((res: any) => {
      this.stats.totalExpenses = res.data?.reduce((sum: number, e: any) => sum + Number(e.exp_amount || 0), 0) || 0;
    });

    this.assetService.getAssets(new HttpParams().set('kalakar_id', userId))
      .subscribe((res: any) => this.stats.assignedAssets = res.data?.length || 0);
  }
}